exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#SharedViewModal .v--modal-box.v--modal{min-height:335px!important;min-width:400px!important}#SharedViewModal :not(.v-icon){font-size:12px}#SharedViewModal .modal__footer{display:none}.disabledBtn{pointer-events:none!important;background:#d3d3d3!important}.disabledPointer{cursor:not-allowed!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-140fad08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/SharedViewModal.vue
// module id = 2004
// module chunks = 0